var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { staticClass: "pt-0 px-0", attrs: { cols: "12" } },
    [
      _c("v-skeleton-loader", {
        staticClass: "bgPanel rounded-0",
        attrs: { type: "image", height: "25" },
      }),
      _c(
        "div",
        { staticClass: "d-flex mt-2 px-5" },
        [
          _c(
            "div",
            { staticClass: "align-stretch" },
            [
              _c("v-skeleton-loader", {
                staticClass: "bgPanel mt-6",
                staticStyle: { "border-radius": "3px" },
                attrs: { type: "image", height: "20", width: "207" },
              }),
              _c("v-skeleton-loader", {
                staticClass: "bgPanel mt-2",
                staticStyle: { "border-radius": "3px" },
                attrs: { type: "image", height: "20", width: "264" },
              }),
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _c("v-skeleton-loader", {
                staticClass: "bgPanel mt-6",
                staticStyle: { "border-radius": "3px" },
                attrs: { type: "image", height: "60", width: "165" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex mt-0 px-5" },
        [
          _c(
            "div",
            { staticClass: "align-stretch" },
            [
              _c("v-skeleton-loader", {
                staticClass: "bgPanel mt-6",
                staticStyle: { "border-radius": "3px" },
                attrs: { type: "image", height: "20", width: "207" },
              }),
              _c("v-skeleton-loader", {
                staticClass: "bgPanel mt-2",
                staticStyle: { "border-radius": "3px" },
                attrs: { type: "image", height: "20", width: "264" },
              }),
              _c("v-skeleton-loader", {
                staticClass: "bgPanel mt-2",
                staticStyle: { "border-radius": "3px" },
                attrs: { type: "image", height: "20", width: "264" },
              }),
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _c("v-skeleton-loader", {
                staticClass: "bgPanel mt-6",
                staticStyle: { "border-radius": "3px" },
                attrs: { type: "image", height: "20", width: "207" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-skeleton-loader", {
        staticClass: "bgPanel mt-6 mb-8 px-5",
        staticStyle: { "border-radius": "3px" },
        attrs: { type: "image", height: "57" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }